module.exports = [
  {
    title: '通用组件',
    collapse: false,
    items: [
      {
        key: 'comp-text',
        text: '文本',
        icon: 'fa-file-text-o'
      }, {
        key: 'comp-image',
        text: '图片',
        icon: 'fa-file-image-o'
      // }, {
      //   key: 'comp-form',
      //   text: '表单',
      //   icon: 'fa-list'
      }, {
        key: 'comp-floor-menu',
        text: '楼层导航',
        icon: 'fa-list-ol'
      }, {
        key: 'comp-timeout',
        text: '倒计时',
        icon: 'fa-hourglass-start'
      }, {
        key: 'comp-bottom-menu',
        text: '底部导航',
        icon: 'fa-adjust'
      }, {
        key: 'comp-grid-menu',
        text: '金刚位',
        icon: 'fa-th'
      }, {
        key: 'comp-empty',
        text: '空白',
        icon: 'fa-file-o'
      },
    ]
  }, {
    title: '业务组件',
    collapse: true,
    items: [
      {
        key: 'comp-grid-header',
        text: '网格标题',
        icon: 'fa-header'
      },
      {
        key: 'comp-grid-list',
        text: '网格单元',
        icon: 'fa-columns'
      },
      {
        key: 'comp-coupon-image',
        text: '优惠券贴图',
        icon: 'fa-file-image-o'
      },
    ]
  }, {
    title: '样式组件',
    collapse: true,
    items: [
      {
        key: 'comp-page-title',
        text: '标题模块',
        icon: 'fa-header'
      }, {
        key: 'comp-page-paragraph',
        text: '段落模块',
        icon: 'fa-paragraph'
      }, {
        key: 'comp-page-intro',
        text: '引言模块',
        icon: 'fa-quote-left'
      }, {
        key: 'comp-page-faq',
        text: 'FAQ模块',
        icon: 'fa-quora'
      }, {
        key: 'comp-page-guide',
        text: '步骤模块',
        icon: 'fa-step-forward'
      }, {
        key: 'comp-page-footer',
        text: '页脚模块',
        icon: 'fa-copyright'
      }
    ]
  }, {
    title: '轮播组件',
    collapse: true,
    items: [
      {
        key: 'comp-swiper-banner',
        text: '轮播图',
        icon: 'fa-caret-square-o-right'
      }, {
        key: 'comp-swiper-card',
        text: '轮播图2',
        icon: 'fa-caret-square-o-right'
      }, {
        key: 'comp-scroll-left',
        text: '横向滚动',
        icon: 'fa-exchange'
      }
    ]
  }, {
    title: '图文列表',
    collapse: true,
    items: [
      {
        key: 'comp-horizontal-list',
        text: '横向列表',
        icon: 'fa-th-list'
      }, {
        key: 'comp-vertical-list',
        text: '纵向列表',
        icon: 'fa-columns'
      }
    ]
  }, {
    title: '动画效果',
    collapse: true,
    items: [
      {
        key: 'comp-news-marquee',
        text: '滚动新闻',
        icon: 'fa-newspaper-o'
      }
    ]
  }
]
